import classNames from "classnames";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import { pillButtonStyleClass } from "source/app/presentation/Shared/Styles/PillButtonStyle";

const dailyGoalsActionPillLayoutClass = StyleClass(
    `dailyGoalsActionPillLayout`,
    {
        margin: `7px 0 4px`,
    }
);

export const dailyGoalsActionPillClass = classNames(
    pillButtonStyleClass,
    dailyGoalsActionPillLayoutClass
);
